import React from 'react'
import "./whereYouNeed.scss"

//Imagens:
import ImgWhereYouNeed from "../../../../assets/dataProtection/ativo-3.svg"
import { useTranslation } from 'react-i18next'

function WhereYouNeed() {
  const {t} =  useTranslation()

  return (
    <div className='container-b2c-profits'>
        <div className="img-b3c-profits">
            <img src={ImgWhereYouNeed} alt="" />
        </div>
        <div className='texts-b2c-profits'>
            <h1>{t("database.title")}</h1>
            <p>{t("database.section_text_1")}</p>
            <p>{t("database.section_text_2")}</p>
            <a href="/form">
              <button id='btn-b3c-profits'>{t("buttons.demo_btn_alternative_text_1")}</button>
            </a>
        </div>
    </div>
  )
}

export default WhereYouNeed